export default "__VITE_ASSET__Bb5XRITH__"